 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTBRUE_ISBN9781936070282_EPUB_COV0_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_cov0_r1'
 import LOVE_1 from '@/components/love_1'
 import TEXTBRUE_ISBN9781936070282_EPUB_HTIT1_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_htit1_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_TITLE2_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_title2_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_DED3_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_ded3_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_CRT4_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_crt4_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_CH1_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_ch1_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_CON6_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_con6_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_CH2_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_ch2_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_C8_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_c8_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_C9_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_c9_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_C10_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_c10_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_C11_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_c11_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_C12_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_c12_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_C13_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_c13_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_C14_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_c14_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_C15_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_c15_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_C16_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_c16_r1'
 import TEXTBRUE_ISBN9781936070282_EPUB_C17_R1 from '@/components/Text/Brue_ISBN9781936070282_epub_c17_r1'
 import LOVE_2 from '@/components/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/Brue_ISBN9781936070282_epub_cov0_r1",
 			"name" : "Text/Brue_ISBN9781936070282_epub_cov0_r1",
 			"component" : TEXTBRUE_ISBN9781936070282_EPUB_COV0_R1
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/Brue_ISBN9781936070282_epub_htit1_r1",
 			"name" : "Text/Brue_ISBN9781936070282_epub_htit1_r1",
 			"component" : TEXTBRUE_ISBN9781936070282_EPUB_HTIT1_R1
 		},
 		{
 			"path" : "/Text/Brue_ISBN9781936070282_epub_title2_r1",
 			"name" : "Text/Brue_ISBN9781936070282_epub_title2_r1",
 			"component" : TEXTBRUE_ISBN9781936070282_EPUB_TITLE2_R1
 		},
 		{
 			"path" : "/Text/Brue_ISBN9781936070282_epub_ded3_r1",
 			"name" : "Text/Brue_ISBN9781936070282_epub_ded3_r1",
 			"component" : TEXTBRUE_ISBN9781936070282_EPUB_DED3_R1
 		},
 		{
 			"path" : "/Text/Brue_ISBN9781936070282_epub_crt4_r1",
 			"name" : "Text/Brue_ISBN9781936070282_epub_crt4_r1",
 			"component" : TEXTBRUE_ISBN9781936070282_EPUB_CRT4_R1
 		},
 		{
 			"path" : "/Text/Brue_ISBN9781936070282_epub_ch1_r1",
 			"name" : "Text/Brue_ISBN9781936070282_epub_ch1_r1",
 			"component" : TEXTBRUE_ISBN9781936070282_EPUB_CH1_R1
 		},
 		{
 			"path" : "/Text/Brue_ISBN9781936070282_epub_con6_r1",
 			"name" : "Text/Brue_ISBN9781936070282_epub_con6_r1",
 			"component" : TEXTBRUE_ISBN9781936070282_EPUB_CON6_R1
 		},
 		{
 			"path" : "/Text/Brue_ISBN9781936070282_epub_ch2_r1",
 			"name" : "Text/Brue_ISBN9781936070282_epub_ch2_r1",
 			"component" : TEXTBRUE_ISBN9781936070282_EPUB_CH2_R1
 		},
 		{
 			"path" : "/Text/Brue_ISBN9781936070282_epub_c8_r1",
 			"name" : "Text/Brue_ISBN9781936070282_epub_c8_r1",
 			"component" : TEXTBRUE_ISBN9781936070282_EPUB_C8_R1
 		},
 		{
 			"path" : "/Text/Brue_ISBN9781936070282_epub_c9_r1",
 			"name" : "Text/Brue_ISBN9781936070282_epub_c9_r1",
 			"component" : TEXTBRUE_ISBN9781936070282_EPUB_C9_R1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js